import {
  FaSolarPanel,
  FaIndustry,
  FaHome,
  FaChargingStation,
  FaShieldAlt,
  FaHandshake,
  FaSun,
  FaTachometerAlt,
  FaLeaf,
  FaPlug,
  FaUserCog,
  FaWarehouse,
  FaBuilding,
  FaSchool,
  FaHospital,
  FaHotel,
  FaShoppingCart,
  FaMobileAlt,
  FaHeadset,
  FaAward,
  FaRocket,
  FaChartLine
} from "react-icons/fa";
import "./ServicesSectionHome.css";
import { Link } from "react-router-dom";

const ServicesSection = () => {
  const mainServices = [
    {
      icon: <FaSolarPanel />,
      title: "Solar EPC Services",
      description: "End-to-end engineering, procurement & construction with quality assurance",
      gradient: "from-blue-500 to-cyan-500",
      features: ["Custom Design", "Quality Materials", "Timely Execution"]
    },
    {
      icon: <FaIndustry />,
      title: "Industrial Solutions",
      description: "High-capacity solar systems for factories and manufacturing units",
      gradient: "from-green-500 to-emerald-500",
      features: ["High Efficiency", "Cost Savings", "24/7 Power"]
    },
    {
      icon: <FaHome />,
      title: "Residential Solar",
      description: "Complete home solar solutions with net metering benefits",
      gradient: "from-purple-500 to-pink-500",
      features: ["Net Metering", "ROI Focused", "Maintenance Free"]
    },
    {
      icon: <FaChargingStation />,
      title: "EV Charging Stations",
      description: "Smart EV charging infrastructure for homes and businesses",
      gradient: "from-orange-500 to-amber-500",
      features: ["Fast Charging", "Smart App", "Grid Integration"]
    }
  ];

  const specializedServices = [
    {
      icon: <FaShieldAlt />,
      title: "AMC & Maintenance",
      description: "Annual maintenance contracts for optimal system performance"
    },
    {
      icon: <FaSun />,
      title: "Off-Grid Systems",
      description: "Independent power solutions for remote locations"
    },
    {
      icon: <FaPlug />,
      title: "Hybrid Systems",
      description: "Grid + Solar + Battery backup integrated solutions"
    },
    {
      icon: <FaUserCog />,
      title: "Consulting",
      description: "Expert guidance for solar project planning and implementation"
    }
  ];

  const commercialServices = [
    { icon: <FaWarehouse />, title: "Warehouses", projects: "150+" },
    { icon: <FaBuilding />, title: "Commercial Complexes", projects: "80+" },
    { icon: <FaSchool />, title: "Educational Institutes", projects: "45+" },
    { icon: <FaHospital />, title: "Hospitals", projects: "30+" },
    { icon: <FaHotel />, title: "Hotels & Resorts", projects: "25+" },
    { icon: <FaShoppingCart />, title: "Shopping Malls", projects: "40+" }
  ];

  const whyChooseUs = [
    {
      icon: <FaAward />,
      title: "ISO Certified",
      description: "Quality certified company with international standards"
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      description: "Round-the-clock technical support and maintenance"
    },
    {
      icon: <FaRocket />,
      title: "Quick Installation",
      description: "Fast project execution with minimal downtime"
    },
    {
      icon: <FaChartLine />,
      title: "Maximum ROI",
      description: "Guaranteed return on investment with energy savings"
    }
  ];

  return (
    <section className="services-home-section">
      {/* Main Services
      <div className="services-main-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-subtitle">Our Services</h2>
            <h1 className="section-title">
              Comprehensive <span>Solar Energy Solutions</span>
            </h1>
            <p className="section-description">
              From residential to industrial scale, we provide end-to-end solar solutions 
              tailored to meet your energy needs and sustainability goals.
            </p>
          </div>

          <div className="main-services-grid">
            {mainServices.map((service, index) => (
              <div key={index} className="main-service-card">
                <div className={`service-icon-container bg-gradient-${service.gradient.split(' ')[1]}`}>
                  {service.icon}
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-features">
                  {service.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag">{feature}</span>
                  ))}
                </div>
                <div className="service-hover-effect"></div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Specialized Services */}
      <div className="specialized-services-section">
        <div className="container">
          <div className="section-header center">
            <h2 className="section-subtitle">Specialized Solutions</h2>
            <h1 className="section-title">
              Advanced Solar <span>Technologies</span>
            </h1>
          </div>

          <div className="specialized-grid">
            {specializedServices.map((service, index) => (
              <div key={index} className="specialized-card">
                <div className="specialized-icon">
                  {service.icon}
                </div>
                <h4>{service.title}</h4>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
           <Link to="/service" className="cta-btn  explore-services-btn mt-4 inline-flex items-center">
          <FaRocket className="btn-icon" />
          <span>Explore All Services</span>
        </Link>
        </div>
      </div>

      {/* Commercial Projects */}
      {/* <div className="commercial-projects-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-subtitle">Our Expertise</h2>
            <h1 className="section-title">
              Commercial & Industrial <span>Projects</span>
            </h1>
            <p className="section-description">
              Successfully delivered solar solutions across various sectors with proven results.
            </p>
          </div>

          <div className="commercial-grid">
            {commercialServices.map((sector, index) => (
              <div key={index} className="sector-card">
                <div className="sector-icon">
                  {sector.icon}
                </div>
                <h4>{sector.title}</h4>
                <div className="projects-count">{sector.projects} Projects</div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Why Choose Us */}
      <div className="why-choose-section">
        <div className="container">
          <div className="section-header center">
            <h2 className="section-subtitle">Why Choose Us</h2>
            <h1 className="section-title">
              Your Trusted Solar <span>Energy Partner</span>
            </h1>
          </div>

          <div className="why-choose-grid">
            {whyChooseUs.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon-wrapper">
                  {feature.icon}
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      {/* <div className="services-cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cta-text">
              <h2>Ready to Go Solar?</h2>
              <p>Get a free consultation and customized solar solution for your needs</p>
            </div>
            <div className="cta-buttons">
              <button className="btn btn-primary">
                <FaMobileAlt />
                Get Free Consultation
              </button>
              <button className="btn btn-secondary">
                <FaHeadset />
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default ServicesSection;